import { useEffect } from "react";

// Smart-TV remote / D-pad support: arrow keys move focus to the nearest control
// by geometry, Enter activates, Back/Escape goes back. Works in TV browsers that
// emit standard arrow keycodes. No external deps.
const SEL = 'a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"]), [data-testid^="content-card-"]';

function visible(el) {
  const r = el.getBoundingClientRect();
  return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
}

export default function TVNavigation() {
  useEffect(() => {
    const onKey = (e) => {
      const keys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
      const typing = e.target?.matches?.("input, textarea, select, [contenteditable='true']");
      if (typing && (e.key === "Enter" || e.key === "ArrowLeft" || e.key === "ArrowRight")) return;
      if (e.key === "Enter") {
        const a = document.activeElement;
        if (a && a !== document.body && SEL.split(",").some((s) => a.matches(s.trim()))) {
          e.preventDefault(); a.click();
        }
        return;
      }
      if ((e.key === "Backspace" || e.key === "Escape") && document.activeElement?.tagName !== "INPUT") {
        return; // let browser/router handle back naturally
      }
      if (!keys.includes(e.key)) return;
      const els = Array.from(document.querySelectorAll(SEL)).filter(visible);
      if (!els.length) return;
      const cur = document.activeElement && els.includes(document.activeElement) ? document.activeElement : null;
      if (!cur) { e.preventDefault(); els[0].focus(); return; }
      const cr = cur.getBoundingClientRect();
      const cx = cr.left + cr.width / 2, cy = cr.top + cr.height / 2;
      let best = null, bestScore = Infinity;
      for (const el of els) {
        if (el === cur) continue;
        const r = el.getBoundingClientRect();
        const x = r.left + r.width / 2, y = r.top + r.height / 2;
        const dx = x - cx, dy = y - cy;
        const dir = e.key === "ArrowRight" ? dx > 8 : e.key === "ArrowLeft" ? dx < -8 : e.key === "ArrowDown" ? dy > 8 : dy < -8;
        if (!dir) continue;
        const along = (e.key === "ArrowLeft" || e.key === "ArrowRight") ? Math.abs(dx) : Math.abs(dy);
        const cross = (e.key === "ArrowLeft" || e.key === "ArrowRight") ? Math.abs(dy) : Math.abs(dx);
        const score = along + cross * 2;
        if (score < bestScore) { bestScore = score; best = el; }
      }
      if (best) { e.preventDefault(); best.focus(); best.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" }); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return null;
}
